module.exports = __webpack_public_path__ + "static/img/back_icon_2.1605258.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back_icon_2.png
// module id = QhT/
// module chunks = 1